import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette }) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      'radial-gradient(circle at top right, #bfcddd 0%, rgb(240, 243, 247)20%)',
    zIndex: -1
  },
  content: {
    padding: 20,
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start'
  },
  textContainer: {
    maxWidth: '600px',
    marginTop: '100px'
  },
  title: {
    marginLeft: '-8px',
    fontWeight: 300,
    marginBottom: '12px',
    color: palette.primary.main
  },
  subtitle: {
    color: '#000',
    fontWeight: 400
  }
}))
